<template>
  <div class="pa-terms">
    <p class="update">最終更新日:2020年12月31日</p>

    <div class="pa-vertical-table">
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">事業者の名称</div>
        <div class="pa-text">XFE（エックスエフイー）</div>
        <div class="pa-option">法人事業者ではありません。個人事業屋号です。</div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">代表者</div>
        <div class="pa-text">
          <div class="text-svg">
            <TokushoName />
          </div>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">所在地</div>
        <div class="pa-text">
          <div class="text-svg text-svg-full">
            <TokushoAddress />
          </div>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">お問い合わせ先（電子メール）</div>
        <div class="pa-text">
          <div class="text-svg text-svg-mid">
            <TokushoEmail />
          </div>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">サービス、デジタルコンテンツの提供価格</div>
        <div class="pa-text">各サービス、デジタルコンテンツの商品ページに表示しております。</div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">サービス及びデジタルコンテンツの提供価格以外に必要となる金銭</div>
        <div class="pa-text">サービス及びデジタルコンテンツをご利用いただくにあたり、必要となるインターネット接続料金、パケット通信料、通信料金等及びその他インターネットをご利用いただく上で必要となる料金はお客様のご負担となります。</div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">サービス及びデジタルコンテンツの提供が行われる時期</div>
        <div class="pa-text">サービス及びデジタルコンテンツの対価をお支払いいただいた後、すぐにご利用いただけます。ただし、購入手続において特定の提供時期が明記されている場合はその時点からのご提供となります。</div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">サービス及びデジタルコンテンツの作動環境</div>
        <div class="pa-text">
          <p>サービス及びデジタルコンテンツをご利用いただくには特定の動作環境が必要となります。</p>
          <p>推奨環境以外ではご購入いただいたサービス及びデジタルコンテンツを正常にご利用いただけない可能性があります。</p>
          <p class="pa-sub-title">【ウェブ上で提供されるサービスの推奨環境】</p>
          <p>Android及びiOSのスマートフォン上で作動している標準のブラウザアプリの最新バージョン</p>
          <p class="pa-sub-mini">（推奨環境は変更される場合はあります。予めご了承ください。）</p>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">販売の条件</div>
        <div class="pa-text">
          <p>当ウェブサイトにてサービス及びデジタルコンテンツをご購入に際しては別途定めている当サービスの利用規約が適応されます。</p>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">キャンセル・返品</div>
        <div class="pa-text">
          <p>デジタルコンテンツの性質上、キャンセル及び返品はお受け致しかねます。</p>
        </div>
      </div>
      <div class="pa-column pa-column-vertical">
        <div class="pa-title">注意事項</div>
        <div class="pa-text">
          <p>当ウェブサイトで提供するサービス及びデジタルコンテンツは特定商取引法に規定されるクーリング・オフが適用されるものではありません。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TokushoName from '@/components/Parts/PATokusho/Images/tokusho_name5.svg?inlineF'
import TokushoAddress from '@/components/Parts/PATokusho/Images/tokusho_address5.svg?inlineF'
import TokushoEmail from '@/components/Parts/PATokusho/Images/tokusho_email3.svg?inlineF'

export default {
  components : {
    TokushoName,
    TokushoAddress,
    TokushoEmail
  }
}
</script>

<style lang="scss">
.pa-vertical-table{
  border-radius: 8px;
  margin:.5rem auto;
  padding:.4rem 0;
  width:98%;
  background:#C8A984;

  .pa-column{
    width:95%;
    margin:1rem auto;

    &:first-child{
      margin-top:.2rem;
    }

    .pa-title{
      border-left:4px solid #a88963;
      border-bottom:2px solid #a88963;
      padding-left:.2rem;
    }

    .pa-text{
      padding:.4rem .2rem;

      .text-svg{
        svg{
          width:3.6rem;
          fill:#363636;
          color:#363636;
        }

        &-full{
          margin-top:.1rem;
          svg{
            width:95%;
            max-width: 22rem;
          }
        }

        &-mid{
          svg{
            width:15rem;
          }
        }
      }

      .pa-sub-title{
        margin-top:.5rem;
        font-weight: bold;
        font-size:.8rem;
      }

      .pa-sub-mini{
        border-radius: 8px;
        background-color: #bea27e;
        padding:.2rem;
        font-size:.65rem;
        text-align: center;
      }
    }

    .pa-option{
      margin-top:-.2rem;
      padding:.2rem .4rem;
      border-radius: 4px;
      font-size:.7rem;
      background:#c4a072;
    }
  }
}
</style>